import { useState } from 'react'

export const useForm = (initialData = {}) => {
  const [formData, setFormData] = useState(initialData)

  const handleInput = (e) => {
    setFormData((prev) => {
      let value = e.target.value
      if (e.target.type === "checkbox") {
        value = e.target.checked
      }
      return {
        ...prev,
        [e.target.name]: value,
      }
    });
  };

  const resetForm = () => setFormData(initialData)

  return {
    formData,
    handleInput,
    resetForm
  }
}
